import { QueryClient } from '@tanstack/svelte-query';
import type { LayoutLoad } from './$types';
import { getRootFooter } from '#lib/features/navigation/utils/getRootFooter/getRootFooter.js';
import { browser } from '$app/env';

export const load: LayoutLoad = async ({ data }) => {
	const queryClient = new QueryClient({
		defaultOptions: {
			queries: {
				enabled: browser,
				staleTime: Infinity,
				refetchOnMount: false,
				refetchOnWindowFocus: false,
			},
		},
	});

	return {
		queryClient,
		// When SvelteKit falls back to rendering the root error page on the
		// client (e.g. a 404), it runs this load with `data` null, so the footer
		// is rebuilt rather than read off it — the error page and footer need it.
		footer: data?.footer ?? getRootFooter(),
	};
};
